<template>
	<ActivityLayout class="kr-progress-activity">
		<template #badge>
			<ValueChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="text"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import ValueChangeActivityBadge from "../Activity/ValueChangeActivityBadge.vue";

export default {
	name: "KRProgressActivity",
	components: {
		ActivityLayout,
		ValueChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, from:String, to:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	computed: {
		text() {
			const { to, from, changedBy, } = this.activity;
			const key = "text";
			return this.translate( key, {
				changedBy,
				to,
				from,
			} );
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.KRProgressActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
